import { HeldRemoteRight } from "../../../bit-components";
import { anyEntityWith } from "../../../utils/bit-utils";
import { paths } from "../paths";
import { Pose } from "../pose";

const calculateCursorPose = (function () {
  const origin = new THREE.Vector3();
  const direction = new THREE.Vector3();
  return function (cursorPose, camera, coords) {
    origin.setFromMatrixPosition(camera.matrixWorld);
    direction.set(coords[0], coords[1], 0.5).unproject(camera).sub(origin).normalize();
    cursorPose.fromOriginAndDirection(origin, direction);
    return cursorPose;
  };
})();

export class AppAwareMouseDevice {
  constructor() {
    this.cursorPose = new Pose();
  }
  write(frame) {
    const transformSystem = AFRAME.scenes[0].systems["transform-selected-object"];

    const buttonLeft = frame.get(paths.device.mouse.buttonLeft);
    const buttonRight = frame.get(paths.device.mouse.buttonRight);
    if (buttonLeft && !this.prevButtonLeft && this.cursorController) {
      const rawIntersections = [];
      this.cursorController.raycaster.intersectObjects(
        AFRAME.scenes[0].systems["hubs-systems"].cursorTargettingSystem.targets,
        true,
        rawIntersections
      );
      const intersection = rawIntersections.find(x => x.object.el);
      const remoteHoverTarget = intersection && findRemoteHoverTarget(intersection.object);
      const userinput = AFRAME.scenes[0].systems.userinput;
      const isInteractable =
        intersection &&
        intersection.object.el.matches(
          ".interactable, .interactable *, .occupiable-waypoint-icon, .teleport-waypoint-icon"
        );
      const isPinned =
        remoteHoverTarget && remoteHoverTarget.components.pinnable && remoteHoverTarget.components.pinnable.data.pinned;
      const isFrozen = AFRAME.scenes[0].is("frozen");
      const template =
        remoteHoverTarget &&
        remoteHoverTarget.components.networked &&
        remoteHoverTarget.components.networked.data.template;
      const isStaticControlledMedia = template && (template === "#static-controlled-media" || template === "#inject-image-media") ;
      const isStaticMedia = template && template === "#static-media";
      this.clickedOnAnything =
        (isInteractable &&
          (isFrozen || !isPinned) &&
          (remoteHoverTarget && canMove(remoteHoverTarget)) &&
          !isStaticControlledMedia &&
          !isStaticMedia) ||
        userinput.activeSets.includes(sets.rightCursorHoldingPen) ||
        userinput.activeSets.includes(sets.rightCursorHoldingInteractable) ||
        userinput.activeSets.includes(sets.rightCursorHoldingCamera);
    }
    this.prevButtonLeft = buttonLeft;

    if ((buttonRight && !transformSystem.transforming) || (buttonLeft && !anyEntityWith(APP.world, HeldRemoteRight))) {
      const movementXY = frame.get(paths.device.mouse.movementXY);
      if (movementXY) {
        frame.setVector2(paths.device.smartMouse.cameraDelta, movementXY[0], movementXY[1]);
      }
      frame.setValueType(paths.device.smartMouse.shouldMoveCamera, true);
    }

    if (!this.camera) {
      this.camera = AFRAME.scenes[0].systems["hubs-systems"].cameraSystem.viewingCamera;
    }

    if (this.camera) {
      frame.setPose(
        paths.device.smartMouse.cursorPose,
        calculateCursorPose(this.cursorPose, this.camera, frame.get(paths.device.mouse.coords))
      );
    }
  }
}
